/**
 * All user-visible text strings for OnBoarding components.
 * Keep every label, placeholder, tooltip, and aria-label here
 * so copy changes happen in one place.
 */
export const ONBOARDING_TEXT = {
  // DocumentField
  DOC_VIEW_BTN: "View",
  DOC_CLOSE_BTN: "Close",

  // RejectedCard
  RC_REASONS_TITLE: "Rejection Reasons",

  // RejectionPanel
  REJECTION_CANCEL_BTN: "Cancel",
  REJECTION_CONFIRM_BTN: "Confirm Rejection",

  // DriverVerificationPanel – header
  DVP_HEADER_TITLE_PREFIX: "Driver Verification:",
  DVP_CLOSE_ARIA: "Close",

  // DriverVerificationPanel – section actions
  DVP_REJECT_BTN: "Reject",
  DVP_UNDO_BTN: "Undo",
  DVP_UNDO_ALL_BTN: "Undo all",
  DVP_REJECT_TOOLTIP: "Please view all documents before rejecting this section",
  DVP_ALL_REJECTED_TEXT: "All fields rejected",
  DVP_SELECT_FIELDS_HINT: "Select the fields or images you want to reject",
  DVP_SELECT_ALL_BTN: "Select all",
  DVP_CLEAR_ALL_BTN: "Clear all",
  DVP_FIELDS_SELECTED_COUNT: (count: number) => `${count} selected`,
  DVP_SELECT_FIELD_ARIA: (label: string) => `Select ${label} for rejection`,
  DVP_FIELDS_REJECTED_COUNT: (count: number) => `${count} field${count === 1 ? "" : "s"} rejected`,

  // DriverVerificationPanel – footer
  DVP_FOOTER_REJECT_BTN: "Reject",
  DVP_FOOTER_APPROVE_BTN: "Approve",

  // ImageCarousel / ZoomOverlay – accessibility
  CAROUSEL_PREV_ARIA: "Previous image",
  CAROUSEL_NEXT_ARIA: "Next image",
  ZOOM_CLOSE_ARIA: "Close zoom",
  IMAGE_ALT_PREFIX: "Document page",
  PREVIEW_ALT_PREFIX: "Preview",
} as const;
